import { render, staticRenderFns } from "./ApprovedList.vue?vue&type=template&id=7e1becef&scoped=true"
import script from "./ApprovedList.vue?vue&type=script&lang=js"
export * from "./ApprovedList.vue?vue&type=script&lang=js"
import style0 from "./ApprovedList.vue?vue&type=style&index=0&id=7e1becef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1becef",
  null
  
)

export default component.exports